import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserTabsRoutingModule } from './user-tabs-routing.module';
import { UserTabsComponent } from './pages/user-tabs/user-tabs.component';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '../../shared/shared.module';
import { SkeletonUserTabsComponent } from './components/skeleton-user-tabs/skeleton-user-tabs.component';

@NgModule({
    declarations: [UserTabsComponent, SkeletonUserTabsComponent],
    imports: [CommonModule, UserTabsRoutingModule, IonicModule, SharedModule],
})
export class UserTabsModule {}
